import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-bd2efe28")
const _hoisted_1 = { class: "video-wrap" }
const _hoisted_2 = ["autoplay"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 您的浏览器不支持查看视频 ")
const _hoisted_4 = ["src"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: _ctx.visible,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (_ctx.visible = $event)),
    onClickOverlay: _ctx.onClickOverlay,
    "close-on-click-overlay": false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("video", {
          ref: "videoRef",
          controls: "",
          autoplay: _ctx.autoplay
        }, [
          _hoisted_3,
          _createElementVNode("source", { src: _ctx.url }, null, 8, _hoisted_4)
        ], 8, _hoisted_2)
      ])
    ]),
    _: 1
  }, 8, ["show", "onClickOverlay"]))
}